export const generateRequiredMsg = (str) => `Enter ${str}!`;
export const generateInvalidMsg = (str) => `${str} field is invalid.`;
